<script setup>
import { inject, computed } from 'vue';
import { GROUP_TYPE } from 'src/utils/config';
import { formatDate } from 'src/utils/base';
import MButton from 'src/components/MButton/index.vue';
import { useIns } from 'src/utils/v2_helper/common';
import Receipt from '../components/Receipt.vue';

const app = useIns();

const order = inject('orderData');

const paidTime = computed(
  () => order.value?.orderDetail?.paidTime?.dbStamp || Date.now(),
);
const price = computed(() => order.value?.orderDetail?.grandTotal || 9999);
const payment = computed(() => order.value?.orderDetail?.payments?.[0] || {});
</script>

<template>
  <div class="succ">
    <div class="succ-top">
      <div class="succ-top_core">
        <div class="succ-top-tile" bold>{{ $t('fullDinein.paySucc') }}</div>
        <div class="succ-top-msg">{{ formatDate(paidTime, 'yyyy.MM.dd HH:mm:ss') }}</div>
        <div class="succ-top-submsg" bold>{{ $n(price, 'currency', 'id-ID') }}</div>
        <div
          v-if="payment.paymentDisplayName"
          class="succ-top-subtile"
        >{{ $t('fullDinein.by') }} {{ payment.paymentDisplayName }}</div>
        <p class="succ-top-tk" bold>{{ $t('fullDinein.thankYou') }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.succ {
  background-repeat: no-repeat;
  background-position: center 0;
  background-image: url('~src/assets/images/result/finishedBg.png');
  background-size: cover;
  &-top {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 370px;
    color: #fff;
    &_core {
      text-align: center;
      div + div {
        line-height: 1.2;
        margin-top: 10px;
      }
    }
    &-tile {
      font-size: 20px;
    }
    &-msg {
      color: #a7f3d0;
    }
    &-subtile {
      color: #a7f3d0;
    }
    &-submsg {
      font-size: 36px;
    }
    &-tk {
      margin: 12px 0 0 0;
      font-size: 20px;
    }
  }
}
</style>
